import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInboxMessage as GetInboxMessageQuery,
    GetInboxMessageVariables as GetInboxMessageQueryVariables,
} from 'nutshell-graphql-types';

import GET_INBOX_MESSAGE from '../queries/get-inbox-message.graphql';

export const useGetInboxMessage = (messageId?: string | null) => {
    const {
        data,
        error,
        loading: isLoading,
        startPolling,
        stopPolling,
    } = useQuery<GetInboxMessageQuery, GetInboxMessageQueryVariables>(GET_INBOX_MESSAGE, {
        skip: !messageId,
        // @ts-expect-error
        variables: {messageId},
    });

    const inboxMessage = data ? data.inboxMessage : null;

    React.useEffect(() => {
        // Start polling if the message is not 'sent' or 'failed'
        if (inboxMessage && !inboxMessage.sentTime && !inboxMessage.failedTime) {
            startPolling(1000); // 1 second
        } else if (inboxMessage && (inboxMessage.sentTime || inboxMessage.failedTime)) {
            stopPolling();
        }
    }, [inboxMessage, startPolling, stopPolling]);

    return {
        inboxMessage,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    };
};
